(function () {
    'use strict';
    
    angular
        .module('app')
        .controller('ChangePasswordController', ChangePasswordController);

    function ChangePasswordController($scope, $stateParams, $state, $rootScope, PasswordService, AuthenticationService, FlashService, toaster) {
        var vm = this;
        vm.changePassword = changePassword;
        vm.isWebApiCallFailed = false;
        //vm.error = "";
        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        vm.userData = { userName  : $rootScope.userName , CurrentPassword : "", NewPassword : "", ConfirmPassword : ""};

        function changePassword(isFormInvalid) {
            vm.isWebApiCallFailed = false;
            if (!isFormInvalid) {
                PasswordService.changePassword(vm.userData).then(function (data) {
                    AuthenticationService.clearCredentials();
                    $rootScope.messageData = { code: "ChangePasswordSuccess", title: "Change Password Success" };
                    $state.go('displayMessage');
                }, function (error, status) {

                    vm.userData.CurrentPassword = "";
                    vm.userData.NewPassword = "";
                    vm.userData.ConfirmPassword = "";

                    vm.isWebApiCallFailed = true;
                    $scope.changepasswordform.$setPristine();
                    $scope.changepasswordform.$setUntouched();

                    var errors = [];
                    if (!error) {
                        errors.push('Server Error. Please contact your system administrator');
                    }
                    else {
                        for (var key in error.ModelState) {
                            for (var i = 0; i < error.ModelState[key].length; i++) {
                                var errText = error.ModelState[key][i];
                                if (errText == "Incorrect password.") { //clean this text up a bit
                                    errText = "Current password is incorrect.";
                                }
                                errors.push(errText);
                            }
                        }
                    }
                    //vm.error = errors;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: errors,
                        timeout: 5000
                    });
                });
            }
        }

        $scope.$watch('vm.userData', function (newObject, oldObject) {
            if (newObject.NewPassword != oldObject.NewPassword) {
                vm.passwordStrength = PasswordService.getStrength(newObject.NewPassword);
                vm.passwordProgressStyle = { width: vm.passwordStrength + '%' };

                if (vm.isPasswordWeak()) {
                    $scope.changepasswordform.password.$setValidity('strength', false);
                } else {
                    $scope.changepasswordform.password.$setValidity('strength', true);
                }
                //console.log(vm.passwordProgressStyle);
            }
        }, true);

        vm.isPasswordWeak = function () {

            return vm.passwordStrength < 40;
        }

        vm.isPasswordOk = function () {

            return vm.passwordStrength >= 40 && vm.passwordStrength <= 70;
        }

        vm.isPasswordStrong = function () {

            return vm.passwordStrength > 70;
        }
    }

})();